/**
 * 商品詳細ページのオーダー情報入力のモーダル表示
 */
export default class OrderModal extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector("[data-target-id=modal-close-button]");
    if (this.closeButton ) {
      this.closeButton.addEventListener("click", () => {
        this.closeModal();
      });
    }
  }

  closeModal() {
    this.classList.remove("-is-active");
  }
}
